import { memo, useRef } from 'react';

// styles
import {
    ParallelAttributeContainer,
    ParallelAttributeLabels,
    ParallelAttributeText,
    ParallelAttributeActionText,
} from './ParallelAttribute.styles.js';

function ParallelAttribute({ color, text, title, isAlwaysExpanded = false, actionLabel, onAction }) {
  const hasAction = !!(onAction && actionLabel);
  const tooltip = title || text;
  const isRunningAction = useRef(false);

  /* A ref rather than state: the action is async, so a second click can land before
     a re-render would have disabled anything. */
  const runAction = async (e) => {
    e.stopPropagation();
    if (isRunningAction.current) return;
    isRunningAction.current = true;
    try {
        await onAction();
    } finally {
        isRunningAction.current = false;
    }
  };

  return (
    <ParallelAttributeContainer
        $color={color}
        $alwaysExpanded={isAlwaysExpanded}
        $hasAction={hasAction}
        title={hasAction ? `${tooltip} — ${actionLabel}` : tooltip}
        role={hasAction ? 'button' : undefined}
        tabIndex={hasAction ? 0 : undefined}
        onClick={hasAction ? runAction : undefined}
        onKeyDown={hasAction ? (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            runAction(e);
        } : undefined}
    >
        <ParallelAttributeLabels>
            <ParallelAttributeText>{text}</ParallelAttributeText>
            {hasAction && <ParallelAttributeActionText>{actionLabel}</ParallelAttributeActionText>}
        </ParallelAttributeLabels>
    </ParallelAttributeContainer>
  );
}

export default memo(ParallelAttribute);
